import { useCallback, useEffect, useState } from 'react';
import { NavLink, Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaRegCopy } from 'react-icons/fa';
import { logout, showToast } from '../redux/slices/authSlice';
import { getList } from '../hooks/api/utils';
import { prefetchRoute } from '../routes/prefetch';
import './sidebar.css';

const prefetchOnHover = (path) => () => prefetchRoute(path);

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [recentOrders, setRecentOrders] = useState([]);
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state?.auth);
  const { referral_link, first_name, last_name } = useSelector((state) => state?.auth?.user) || {};

  const fetchRecentOrders = useCallback(() => {
    if (!user) return;
    getList('/orders/order-list/', () => {}, setRecentOrders);
  }, [user]);

  useEffect(() => {
    fetchRecentOrders();
  }, [fetchRecentOrders, location.pathname]);

  useEffect(() => {
    const onOrdersUpdated = () => fetchRecentOrders();
    window.addEventListener('orders-updated', onOrdersUpdated);
    return () => window.removeEventListener('orders-updated', onOrdersUpdated);
  }, [fetchRecentOrders]);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/signin');
  };

  const copyToClipboard = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const referralUrl = `${window.location.origin}${referral_link}`;
    navigator.clipboard.writeText(referralUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className={`sidebarMain${collapsed ? ' collapsed' : ''}`}>

      <div className="logoPart">
        {collapsed ? (
          <>
            <div className="switchs" onClick={() => setCollapsed(false)}>
              <img src="/images/switch.png" className="switch2" alt="open sidebar" />
            </div>
            <div className="logo">
              <img src="/images/logom.webp" className="logos" alt="logo" />
            </div>
          </>
        ) : (
          <>
            <div className="logo">
              <Link to="/home" onMouseEnter={prefetchOnHover('/home')}>
                <img src="/images/logom.webp" className="logos" alt="logo" />
                <img src="/images/logom2.webp" className="logol" alt="logo text" />
              </Link>
            </div>
            <div className="switchs" onClick={() => setCollapsed(true)}>
              <img src="/images/switch.png" className="switch2" alt="close sidebar" />
            </div>
          </>
        )}
      </div>

      <div className="linkPart">
        <ul>
          <li>
            <NavLink to="/chatbot" title="New Order" onMouseEnter={prefetchOnHover('/chatbot')}>
              <img src="/images/greenplus.png" alt="" />
              {!collapsed && <span>New Order</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/area-interests" title="Areas of Interests" onMouseEnter={prefetchOnHover('/area-interests')}>
              <img src="/images/star.png" alt="" />
              {!collapsed && <span>Areas of Interests</span>}
            </NavLink>
          </li>
          
        </ul>
      </div>

      {!collapsed && (
        <div className="recentOrder">
          <h5>Recent Orders</h5>
          <ul>
            {recentOrders.length > 0 ? (
              recentOrders.slice(0, 5).map((order) => {
                const names =
                  order.service_names?.filter(Boolean).join(", ") || "Order";
                const orderNo = String(order.id).padStart(3, "0");
                return (
                  <li key={order.id}>
                    <Link
                      to="/orderlist-details"
                      state={{ id: order.id }}
                      className="d-inline-flex align-items-center"
                      style={{ maxWidth: "100%" }}
                    >
                      <span className="text-truncate">{names}</span>
                      <span className="flex-shrink-0 ms-1">#{orderNo}</span>
                    </Link>
                  </li>
                );
              })
            ) : (
              <li className="no-orders">No orders yet</li>
            )}
          </ul>
        </div>
      )}

      {collapsed && <div style={{ flex: 1 }} />}

      <div className="profileBottom">
        {profileOpen && (
          <div className="dropProfile">
            <ul className="mb-0">
              <li><NavLink to="/orderlist" onClick={() => setProfileOpen(false)} onMouseEnter={prefetchOnHover('/orderlist')}>Orders</NavLink></li>
              <li><NavLink to="/moredetails" onClick={() => setProfileOpen(false)} onMouseEnter={prefetchOnHover('/moredetails')}>Update Profile</NavLink></li>
              <li><NavLink to="/add-address" onClick={() => setProfileOpen(false)} onMouseEnter={prefetchOnHover('/add-address')}>Saved Address</NavLink></li>
              <li><NavLink to="/wallet" onClick={() => setProfileOpen(false)} onMouseEnter={prefetchOnHover('/wallet')}>Wallet</NavLink></li>
              <li><NavLink to="/change-password" onClick={() => setProfileOpen(false)} onMouseEnter={prefetchOnHover('/change-password')}>Change Password</NavLink></li>
              <li><NavLink to="/refferal-users" onClick={() => setProfileOpen(false)} onMouseEnter={prefetchOnHover('/refferal-users')}>Referred Users</NavLink></li>
              <li>
                <div className="inviteItem">
                  {!collapsed && (
                    <span className="inviteRow">
                      Invite Your Friends
                      <button
                        className="copyBtn"
                        onClick={copyToClipboard}
                        title="Copy referral link"
                      >
                        <FaRegCopy />
                        {copied ? ' Copied!' : ' Copy'}
                      </button>
                    </span>
                  )}
                </div>
              </li>
              <li>
                <a href="#" onClick={(e) => { e.preventDefault(); setProfileOpen(false); handleLogout(); }}>
                  Log Out
                </a>
              </li>
            </ul>
          </div>
        )}
        <div className="profileB" onClick={() => setProfileOpen(!profileOpen)}>
          <img src="/images/profile.svg" className="userImg" alt="user" />
          {!collapsed && <h6>{first_name} {last_name} <span>Account Settings</span></h6>}
          {!collapsed && <img src="/images/rightArw.png" className="rightArw" alt="" />}
        </div>
      </div>

    </div>
  );
};

export default Sidebar;
